import News_main from './NewsMain.vue';
//import GwNoticeText from './GwNoticeText.vue';

export default {
    News_main,
   // GwNoticeText
}